import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import React from 'react';
import Sticky from 'react-sticky-el';
import './style.scss';

const StickyComponent = ({ fields = {}, rendering }) => {
  const variation = rendering?.params?.stickyType?.toLowerCase();

  const renderStickyComponent = () => {
    if (variation === 'left') {
      return (
        <div
          className={clsx(
            'sticky__component--parent content',
            'add-margins',
            rendering?.params?.Styles
          )}
        >
          <div className="sticky__component--left">
            <Sticky
              className="sticky__component--right_sticky"
              bottomOffset={0}
              boundaryElement=".sticky__component--parent"
            >
              <Placeholder name="left-side" rendering={rendering} />
            </Sticky>
          </div>
          <div className="sticky__component--right">
            <Placeholder name="right-side" rendering={rendering} />
          </div>
        </div>
      );
    } else {
      return (
        <div
          className={clsx(
            'sticky__component--parent content',
            'add-margins',
            rendering?.params?.Styles
          )}
        >
          <div className="sticky__component--left">
            <Placeholder name="left-side" rendering={rendering} />
          </div>
          <div className="sticky__component--right">
            <Sticky
              className="sticky__component--right_sticky"
              bottomOffset={0}
              boundaryElement=".sticky__component--parent"
            >
              <Placeholder name="right-side" rendering={rendering} />
            </Sticky>
          </div>
        </div>
      );
    }
  };

  return renderStickyComponent();
};

export default StickyComponent;
